import { IReleaseNote } from "../types"

export const RELEASE_1_4_5: IReleaseNote = {
    status: "PAST",
    title: "v1.4.5",
    date: "1st October 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content: "Patch 1.4.5 includes an update to the MPAN lookup logic",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "We have updated the logic to improve the chances of multi-word house names getting a successful match with our lookup service",
                "The search address tooltip has been updated to provide clearer guidance on formatting multi-word house addresses",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "The following change has been been added:",
            bullets: [
                "We have updated the logic to improve the chances of multi-word house names getting a successful match with our lookup service",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "We have updated the MPAN lookup logic for multi-word house names, for a more successful match with our lookup service",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            content: "The following change has been been added:",
            bullets: ["This release contains no changes to your functionality"],
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
